import { render, staticRenderFns } from "./AccessRecords.vue?vue&type=template&id=6a5bb604&scoped=true"
import script from "./AccessRecords.vue?vue&type=script&lang=js"
export * from "./AccessRecords.vue?vue&type=script&lang=js"
import style0 from "./AccessRecords.vue?vue&type=style&index=0&id=6a5bb604&prod&lang=scss&scoped=true"
import style1 from "./AccessRecords.vue?vue&type=style&index=1&id=6a5bb604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5bb604",
  null
  
)

export default component.exports